import Navbar from "../Components/Navbar";
import Cards from "../Components/Card";
import Jumbotron from "../Components/Jumbotron";
import Contents from "../Components/Group";
import Footer from "../Components/Footer";
import Button from "../Components/Button";
import { useEffect, useState } from "react";
import { useCustomQuery } from "../config/query";
import { User } from "../utils/profile";

const Home = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [profile, setProfile] = useState();
  let { data } = useCustomQuery("profile", User);

  useEffect(() => {
    if (data) {
      setProfile(data);
    }
  }, [data]);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <>
      <Navbar data={profile} />
      <Jumbotron />
      <Button onSearch={handleSearch} />
      <Cards />
      <Contents searchTerm={searchTerm} />
      <Footer />
    </>
  );
};

export default Home;
